import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsExpected = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.84375 2.21973C6.15734 1.76403 6.84266 1.76403 7.15625 2.21973L7.21777 2.32422L8.1543 4.22266L10.25 4.52734C10.9062 4.62269 11.1681 5.42877 10.6934 5.8916L9.17676 7.36914L9.53516 9.45703C9.64715 10.1105 8.96089 10.6083 8.37402 10.2998L6.5 9.31348L4.62598 10.2998C4.03911 10.6083 3.35285 10.1105 3.46484 9.45703L3.82227 7.36914L2.30664 5.8916C1.83186 5.42877 2.09383 4.62269 2.75 4.52734L4.84473 4.22266L5.78223 2.32422L5.84375 2.21973Z",
		fill: "#6C9CFA",
		stroke: "#C4D7FD"
	})
});
export default SvgAsExpected;
